// Utility functions for Next Best Action table

import { MetricDirection, MetricRecommendation } from '../features/coachingAction/prepareStep/prepare-types';
import Growth from '../assets/Growth.svg';
import DownGrowth from '../assets/DownGrowth.svg';

import trendUp from '../assets/trendUp.svg';
import trendDown from '../assets/trendDown.svg';

/**
 * Get metric direction icon image
 * @param directionId - Metric direction ID (1=Ascending, 2=Descending)
 */
export const getMetricDirectionImage = (directionId: number): string => {
    switch (directionId) {
        case MetricDirection.Ascending:
            return trendUp;
        case MetricDirection.Descending:
            return trendDown;
        default:
            return '';
    }
};

export const getMetricRecommendationImage = (recommendation: number): string => {
    switch (recommendation) {
        case MetricRecommendation.Yes:
            return Growth;
        case MetricRecommendation.No:
            return DownGrowth;
        default:
            return '';
    }
};

/**
 * Get color class based on metric attainment
 * @param attained - Whether metric was attained
 */
export const getMetricAttainmentColor = (attained: boolean): string => {
    return attained ? 'text-success' : 'text-danger';
};
